import { liteClient as algoliasearch } from 'algoliasearch/lite';
import type { LiteClient } from 'algoliasearch/lite';
import { normalizeAlgoliaSearchQuery } from './utils/global/normalizeAlgoliaSearchQuery';

const tempKey = '89fd2a4fe9f385a3bc60fd404e9e4192';
const tempAppId = '2P8K2UAGEG';
let tempIndex = 'dev_porter';

if (window.location.hostname === 'app.getporter.io') {
  tempIndex = 'prod_PORTER';
}

export const API_KEY = tempKey;
export const APP_ID = tempAppId;
export const INDEX = tempIndex;

type SearchArgs = Parameters<LiteClient['search']>;

function normalizeSearchMethodParams(
  searchMethodParams: SearchArgs[0],
): SearchArgs[0] {
  if (Array.isArray(searchMethodParams)) {
    return searchMethodParams.map(request => ({
      ...request,
      params: {
        ...request.params,
        query: normalizeAlgoliaSearchQuery(request.params?.query ?? ''),
      },
    }));
  }

  return {
    ...searchMethodParams,
    requests: searchMethodParams.requests.map(request => {
      if (!('query' in request) || typeof request.query !== 'string') {
        return request;
      }
      return {
        ...request,
        query: normalizeAlgoliaSearchQuery(request.query),
      };
    }),
  };
}

const baseClient = algoliasearch(APP_ID, API_KEY);

export const searchClient: LiteClient = {
  ...baseClient,
  search<T>(...args: SearchArgs) {
    const [searchMethodParams, requestOptions] = args;
    return baseClient.search<T>(
      normalizeSearchMethodParams(searchMethodParams),
      requestOptions,
    );
  },
};
